import http from '@/common/utils/http-common';
import Phone from '@/types/Phone.type';

class PhoneService {
  getAll() {
    return http.get('/phones');
  }

  get(id: string) {
    return http.get(`/phones/${id}`);
  }

  create(data: Phone) {
    return http.post('/phones', data);
  }

  update(data: Phone, id: string) {
    return http.put(`/phones/${id}`, data);
  }

  delete(id: any) {
    return http.delete(`/phones/${id}`);
  }
}

export default new PhoneService();
